<template>
    <multiselect
            :id="selectOptions.id"
            :options="options"
            :value="value"
            :multiple="selectOptions.multiple"
            :track-by="selectOptions.trackBy || null"
            :label="selectOptions.label || null"
            :searchable="true"
            :clear-on-select="selectOptions.clearOnSelect"
            :hide-selected="selectOptions.hideSelected"
            :placeholder="schema.placeholder"
            :allow-empty="selectOptions.allowEmpty"
            :reset-after="selectOptions.resetAfter"
            :close-on-select="selectOptions.closeOnSelect"
            :custom-label="customLabel"
            :taggable="selectOptions.taggable"
            :tag-placeholder="selectOptions.tagPlaceholder"
            :max="schema.max || null"
            :options-limit="selectOptions.optionsLimit"
            :group-values="selectOptions.groupValues"
            :group-label="selectOptions.groupLabel"
            :block-keys="selectOptions.blockKeys"
            :internal-search="false"
            :select-label="selectOptions.selectLabel"
            :selected-label="selectOptions.selectedLabel"
            :deselect-label="selectOptions.deselectLabel"
            :show-labels="selectOptions.showLabels"
            :limit="selectOptions.limit"
            :limit-text="selectOptions.limitText"
            :loading="isLoading"
            :disabled="disabled"
            :max-height="selectOptions.maxHeight"
            :show-pointer="selectOptions.showPointer"
            @input="updateSelected"
            @select="onSelect"
            @remove="onRemove"
            @search-change="onSearchChange"
            @tag="addTag"
            @open="onOpen"
            @close="onClose"
            :option-height="selectOptions.optionHeight"
            :open-direction="selectOptions.openDirection"
    >
        <template slot="noOptions">
            {{ $t('_empty_list') }}
        </template>
    </multiselect>
</template>
<script>
// @see https://github.com/vue-generators/vue-form-generator/issues/316#issuecomment-362393333
import { abstractField } from 'vue-form-generator'

export default {
  mixins: [abstractField],
  data () {
    return {
      options: [],
      isLoading: false
    }
  },
  computed: {
    selectOptions () {
      return this.schema.selectOptions || {}
    },
    customLabel () {
      if (typeof this.selectOptions.customLabel !== 'undefined') {
        return this.selectOptions.customLabel
      }

      if (typeof this.schema.selectOptions !== 'undefined' && typeof this.schema.selectOptions.customLabel !== 'undefined' && typeof this.schema.selectOptions.customLabel === 'function') {
        return this.schema.selectOptions.customLabel
      } else {
        // this will let the multiselect library use the default behavior if customLabel is not specified
        return undefined
      }
    }
  },
  methods: {
    updateSelected (value /* , id */) {
      this.value = value
    },
    addTag (newTag, id) {
      let onNewTag = this.selectOptions.onNewTag
      if (typeof onNewTag === 'function') {
        onNewTag(newTag, id, this.options, this.value)
      }
    },
    onSearchChange (searchQuery, id) {
      this.isLoading = true
      this.schema.selectOptions.apiObject.search(searchQuery).then(
        response => {
          this.options = this.schema.selectOptions.apiObject.parseApiObject(response.data)

          // Append already selected value to options list
          if (this.value) {
            this.options.push(this.value)
          }

          this.isLoading = false
        }
      )
    },
    onSelect (/* selectedOption, id */) {
      // console.log("onSelect", selectedOption, id);
    },
    onRemove (/* removedOption, id */) {
      // console.log("onRemove", removedOption, id);
    },
    onOpen (/* id */) {
      // console.log("onOpen", id);
    },
    onClose (/* value, id */) {
      // console.log("onClose", value, id);
    }
  },
  created () {
    // Check if the component is loaded globally
    if (!this.$root.$options.components['multiselect']) {
      throw new Error("'vue-multiselect' is missing. Please download from https://github.com/monterail/vue-multiselect and register the component globally!")
    }

    // load some values from api
    this.options = []
    this.schema.selectOptions.apiObject.search(undefined, [], this.schema.selectOptions.parentApiObject).then(response => (this.options = this.schema.selectOptions.apiObject.parseApiObject(response.data)))

    // Append already selected value to options list
    if (this.value) {
      this.options.push(this.value)
    }
  }
}
</script>
